import React from 'react';
import { useAuth } from '../context/AuthContext';
import AdminInventory from './AdminInventory';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const EmployeeInventoryPage = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  // Check if user has inventory permission
  if (!user?.effectivePermissions?.pages?.inventory) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex justify-center items-center p-4">
        <div className="text-center max-w-md">
          <ExclamationTriangleIcon className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            {t('accessDenied.title')}
          </h2>
          <p className="text-gray-600 mb-4">
            {t('accessDenied.inventoryMessage')}
          </p>
          <p className="text-sm text-gray-500">
            {t('accessDenied.contactAdmin')}
          </p>
        </div>
      </div>
    );
  }

  // Render AdminInventory with employee-specific modifications
  return (
    <div className="space-y-4">
      {/* Employee-specific header */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon className="h-5 w-5 text-blue-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              {t('employeeAccess.restrictedAccess')}
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>{t('employeeAccess.inventoryDescription')}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Render the actual AdminInventory */}
      <AdminInventory isEmployeeView={true} />
    </div>
  );
};

export default EmployeeInventoryPage;
